"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplatesForGroup = exports.getTemplateList = exports.getTemplate = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _defaultTemplate = _interopRequireDefault(require("./components/defaultTemplate"));
var _plugins = _interopRequireDefault(require("./plugins.js"));
var _flat = _interopRequireDefault(require("flat"));
var _checkDuplicateTemplateNames = _interopRequireDefault(require("./checkDuplicateTemplateNames.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function addTemplatesFromContext(context, templates) {
  if (!context) {
    return {};
  }
  (0, _forEach2["default"])(context.keys(), function (key) {
    var group = key.replace(/^.*\/([^/]+)\/[^/]+\/[^/]+\/index\.js$/, '$1');
    var type = key.replace(/^.*\/([^/]+)\/[^/]+\/index\.js$/, '$1');
    var template = context(key);
    templates[group] = templates[group] || {};
    templates[group][type] = templates[group][type] || [];
    templates[group][type].push(template["default"] ? template["default"] : template);
  });
}
function addTemplatesFromPlugins(templates) {
  if (!_plugins["default"].templates) {
    return;
  }
  var list = (0, _flat["default"])(_plugins["default"].templates, {
    maxDepth: 2
  });
  (0, _forEach2["default"])(list, function (value, key) {
    var _key$split = key.split('.'),
      _key$split2 = _slicedToArray(_key$split, 2),
      group = _key$split2[0],
      type = _key$split2[1];
    templates[group] = templates[group] || {};
    templates[group][type] = templates[group][type] || [];
    templates[group][type] = [].concat(_toConsumableArray(templates[group][type]), _toConsumableArray(value));
  });
}
var templatesContext = isTestEnv() ? null : require.context('./templates', true, /^\.\/([^/]+\/){2}index\.js$/);
var appTemplatesContext = isTestEnv() ? null : require.context('resources/assets/js', true, /^\.\/vendor\/flow\/templates\/(components|players)\/([^/]+\/){2}index\.js$/);
var templates = {
  players: {
    flow: [_defaultTemplate["default"]]
  }
};
addTemplatesFromContext(templatesContext, templates);
addTemplatesFromContext(appTemplatesContext, templates);
addTemplatesFromPlugins(templates);
(0, _checkDuplicateTemplateNames["default"])(templates);
var getTemplateList = function getTemplateList(group, type) {
  if (!templates[group] || !templates[group][type]) {
    return [];
  }
  return templates[group][type].map(function (template) {
    return _objectSpread({
      defaultSettings: {},
      settingsComponent: null
    }, template);
  });
};
exports.getTemplateList = getTemplateList;
var getTemplatesForGroup = function getTemplatesForGroup(group) {
  if (!templates[group]) {
    return {};
  }
  return (0, _mapValues2["default"])(templates[group], function (type) {
    return type.map(function (template) {
      return _objectSpread({
        defaultSettings: {},
        settingsComponent: null
      }, template);
    });
  });
};
exports.getTemplatesForGroup = getTemplatesForGroup;
var getTemplate = function getTemplate(group, type, name) {
  if (!templates[group] || !templates[group][type]) {
    return null;
  }
  var template = (0, _find2["default"])(templates[group][type], {
    name: name
  });
  if (!template) {
    return null;
  }
  return template;
};
exports.getTemplate = getTemplate;
function isTestEnv() {
  return !!(process && process.env && process.env.NODE_ENV === 'test');
}